import React from 'react';
import Button from '../../Button';
import { PlatformTabStyle } from './PlatformTab.styles';
import Form, { useForm } from '../../Form';
import Field from '../../Field';

const options = [
  { label: 'Light', value: 'Light' },
  { label: 'Dark', value: 'Dark' },
  { label: 'System', value: 'System' },
];

const PlatformTab = () => {
  const [form] = useForm();

  return (
    <>
      <PlatformTabStyle>
        <Form form={form}>
          <div className="holder">
            <strong className="title">Appearance</strong>
            <div className="select-box">
              <Form.Item
                options={options}
                type="select"
                rounded
                name="select"
                placeholder="System"
                rules={[
                  {
                    required: true,
                    message: 'response model is required',
                  },
                ]}>
                <Field />
              </Form.Item>
            </div>
          </div>
        </Form>
      </PlatformTabStyle>
    </>
  );
};

export default PlatformTab;
